import GenerateAICVBanner from './GenerateAICVBanner'
export default GenerateAICVBanner
